import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef, useCallback, memo } from 'react'

import { FormControl, InputLabel, Input, FormHelperText, Alert, Dialog } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, getAction, printVariable, comma } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase, Divider } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import MyDialog3 from '@components/MyDialog3'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import ManagerLecturePartDetail from './manager-lecture.part.detail'
import useAlert from '@hooks/useAlert'
import ConfirmDialog from '@components/ConfirmDialog'
import { useLocation, useParams } from 'react-router-dom'
import ManagerLecturePartUpload from '@pages/manager/manager-lecture.part.upload'
import ManagerLecturePartImg from '@pages/manager/manager-lecture.part.img'
import no_image from '@images/no_image.png'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'

import { useLoading } from '@context/LoadingContext'
import IndiTrigger from '@components/IndiTrigger'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import Skeleton from '@mui/material/Skeleton'
import ManagerLecturePartUpload2 from './manager-lecture.part.upload2'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import { tab } from '@testing-library/user-event/dist/tab'
import ManagerLecturePartPriorUpload from './manager-lecture.part.prior.upload'
import ConstructionIcon from '@mui/icons-material/Construction'
import SettingsIcon from '@mui/icons-material/Settings'
import DeleteIcon from '@mui/icons-material/Delete'
import TableSortLabel from '@mui/material/TableSortLabel'
import { set } from 'lodash'
const customTheme = createTheme({
  typography: {
    fontSize: 12,
  },
  spacing: 4,
  components: {},
})
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`

const RLTN_CODE = 'S003'
const weekOrder = { 월: 1, 화: 2, 수: 3, 목: 4, 금: 5, 토: 6, 일: 7 }
export const fetchRegis = async (lectureId) => {
  const url = '/regi/lecture'
  const params = { lectureId: lectureId }
  const resp = await WebService.get(url, params)
  if (resp.repCode !== 'ack') {
    console.log(resp.repMessage)
    return
  }

  const repMessage = JSON.parse(resp.repMessage)
  return JSON.parse(repMessage.records)
}

export const fetchRegis2 = async (smstId) => {
  const url = `/regi/smst/${smstId}`
  const resp = await WebService.get(url)
  if (resp.repCode !== 'ack') {
    console.log(resp.repMessage)
    return
  }

  const repMessage = JSON.parse(resp.repMessage)
  return JSON.parse(repMessage.records)
}

export const fetchSmst = async (lectureId) => {
  const url = `/smst/lecture/${lectureId}`
  const resp = await WebService.get(url)
  if (resp.repCode !== 'ack') {
    console.log(resp.repMessage)
    return
  }

  const repMessage = JSON.parse(resp.repMessage)
  return JSON.parse(repMessage.record)
}

export const transformData = (records, currentSortBy, currentDirection) => {
  const recordsArray = Array.isArray(records) ? records : []
  const weekOrder = { 월: 1, 화: 2, 수: 3, 목: 4, 금: 5, 토: 6, 일: 7 }
  const weekMap = { S001: '월', S002: '화', S003: '수', S004: '목', S005: '금', S006: '토', S007: '일' }
  // 데이터 가공 (요일 정렬 시 '폭발(Explode)', 그 외 '압축(Compact)')
  let processed = []
  if (currentSortBy === 'weekString') {
    // flatMap 대신 reduce를 사용하여 수동으로 펼치기 (가장 안전)
    processed = recordsArray.reduce((acc, lecture) => {
      const schedules = lecture.lschs || []
      const exploded = schedules.map((sch, index) => ({
        ...lecture,
        weekString: `${weekMap[sch.weekCode] || ''}(${sch.startTime}~${sch.endTime})`,
        dueTime: `(${sch.startTime}~${sch.endTime})`,
        drop: index !== 0,
        sortKey: sch.weekCode,
      }))
      return acc.concat(exploded)
    }, [])

  }
  else {
    // 일반 정렬은 그대로 유지
    processed = recordsArray.map((lecture) => ({
      ...lecture,
      weekString: (lecture.lschs || []).map(l =>
        `${weekMap[l.weekCode] || ''}(${l.startTime}~${l.endTime})`
      ).join('\n'),
      dueTime: lecture.lschs.length > 0 ? `(${lecture.lschs[0].startTime}~${lecture.lschs[0].endTime})` : '',
      drop: false,
      sortKey: lecture[currentSortBy] || '',
      // sortKey: currentSortBy || '',
    }))
  }

  // 학기별 그룹핑 및 정렬
  const groups = processed.reduce((acc, cur) => {
    const key = `${cur.year}/${cur.gisu}`
    if (!acc[key]) acc[key] = []
    acc[key].push(cur)
    cur.groupId = key
    return acc
  }, {})

  const sortedResult = {}
  Object.keys(groups)
    .sort()
    .reverse()
    .forEach((key) => {
      sortedResult[key] = groups[key].sort((a, b) => {
        if (currentSortBy === 'weekString') {
          // weekCode(S001~S007)로 요일 순서를 잡고 타이틀로 2차 정렬
          // return a.sortKey.localeCompare(b.sortKey) || a.title.localeCompare(b.title)
          const res = a.sortKey.localeCompare(b.sortKey) || a.title.localeCompare(b.title)
          return currentDirection === 'asc' ? res : -res
        }

        // 일반 컬럼 정렬 (가나다순 등)
        const res = ('' + a.sortKey).localeCompare('' + b.sortKey)
        return currentDirection === 'asc' ? res : -res
      })
    })

  // console.log('sortedResult=>', sortedResult)
  return sortedResult
}

const ImageCell22 = ({ id, imgUrl, recordRef }) => {
  const imgHandler = useState(false)
  const { alert, renderAlert } = useAlert()
  const handleViewImage = () => {
    if (recordRef.current.imgUrl.startsWith('data:')) {
      alert('이미지가 없습니다.')
    }
    else {
      imgHandler[1](true)
    }
  }

  return (
    <>
      <div onClick={() => handleViewImage()} style={{ cursor: 'pointer' }}>
        <LazyLoadImage src={imgUrl} width={30} height={30} placheholder=<Skeleton wvariant="rectangular" width={30} height={30} /> />
      </div>
      {imgHandler[0] ? <ManagerLecturePartImg dialogHandler={imgHandler} imgUrl={imgUrl} /> : null}
      {renderAlert()}
    </>
  )
}

const ManagerLecturePage = () => {
  console.log('ManagerLecturePage rendering...')
  const { more } = useParams()
  const g_sel_code = 'SA07'
  const g_stat_code = 'SA08'
  const g_week_code = 'SB07'
  const theme = useTheme()
  const inputRef = useRef()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const [smstList, set_smstList] = useState([])
  const uploadHandler = useState(false)
  const [tabValue, set_tabValue] = useState('1')
  const prev_tabValueRef = useRef(tabValue)
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)

  const location = useLocation()
  const curLocationRef = useRef(location)

  const [sortBy, set_sortBy] = useState(() => {
    return localStorage.getItem('lastSortBy') || 'title'
  })

  const [sortDirection, set_sortDirection] = useState('asc')
  const [counter, set_counter] = useState(0)
  const originRef = useRef({})

  const handleSort = (property) => {
    //  같은 컬럼을 또 클릭했으면 방향을 뒤집고, 새로운 컬럼이면 'asc'로 시작
    const isAsc = sortBy === property && sortDirection === 'asc'
    const direction = isAsc ? 'desc' : 'asc'

    set_sortBy(property)
    set_sortDirection(direction)

    localStorage.setItem('lastSortBy', property)
    set_counter((prev) => prev + 1)
  }

  const weekCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === g_week_code)
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])

  const selCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === g_sel_code)
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])

  const statCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === g_stat_code)
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])

  const dgRef = useRef()
  const dgRef2 = useRef()

  const fields = [
    // { field: 'id', placeholder: '아이디', type: 'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList: [] },
    { field: 'groupId', placeholder: '년도/기수', type: 'text', value: '', visible: detailScreen, canSrch: false, selList: smstList },
    { field: 'smstName', placeholder: '년도/기수', type: 'select', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'id', placeholder: '강좌ID', type: 'text', value: -1, visible: true, canSrch: false, selList: [] },
    { field: 'prevId', placeholder: '선행강좌ID', type: 'text', value: 0, visible: more && more === 'more', canSrch: false, selList: [] },
    { field: 'userId', placeholder: '강사명', type: 'select', value: -1, visible: detailScreen, canSrch: false, selList: [] },
    { field: 'title', placeholder: '강좌 제목', type: 'text', value: '', visible: true, canSrch: false, selList: [], sortable: true },
    { field: 'weekString', placeholder: '요일', type: 'checkbox', value: '', visible: !detailScreen, canSrch: false, selList: [], sortable: true },
    { field: 'imgUrl', placeholder: '소개파일', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'teacherName', placeholder: '강사명', type: 'text', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'weekCode', placeholder: '요일', type: 'checkbox', value: '', visible: false, canSrch: false, selList: weekCodeList },
    { field: 'ltgString', placeholder: '대상학년', type: 'checkbox', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'loc', placeholder: '장소', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'feeAll', placeholder: '요금', type: 'text', value: '', visible: true, canSrch: false, selList: [], width: 130 },
    { field: 'lecCount', placeholder: '횟수', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'feePerTime', placeholder: '1회요금', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'rrsNum', placeholder: '모집/신청/진행/등록', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'rcrNum', placeholder: '모집인원', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'reqNum', placeholder: '신청인원', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'pcrNum', placeholder: '진행인원', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'sttNum', placeholder: '수강인원', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'selCode', placeholder: '선발방식', type: 'select', value: '', visible: detailScreen, canSrch: false, selList: selCodeList },
    { field: 'selName', placeholder: '선발방식', type: 'select', value: '', visible: true, canSrch: false, selList: selCodeList },
    { field: 'statCode', placeholder: '상태', type: 'select', value: '', visible: detailScreen, canSrch: false, selList: statCodeList },
    { field: 'statCodeName', placeholder: '상태', type: 'select', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'content', placeholder: '내용', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'regTime', placeholder: '등록일시', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'uptTime', placeholder: '수정일시', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
  ]
  // const [fields, set_fields] = useState([...defFields])

  const gdnFields = [
    { field: 'name', placeholder: '성명' },
    { field: 'loginId', placeholder: 'ID' },
    { field: 'phone', placeholder: '전화번호' },
    { field: 'phoneCertYn', placeholder: '인증여부' },
  ]

  const regiLectureFields = [
    { field: 'title', placeholder: '강좌제목', table: 'lecture' },
    { field: 'statCode', placeholder: '강좌상태', table: 'lecture', fn: (code) => findCode('SA09', code) },
    { field: 'statCode', placeholder: '신청상태', table: 'regi', fn: (code) => findCode('SA12', code) },
    { field: 'regCode', placeholder: '등록상태', table: 'regi', fn: (code) => findCode('SB12', code) },
  ]

  const feeCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === 'SA21')
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])

  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })

  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ''))
  const [dataList, set_dataList] = useState([])

  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const termsRef = useRef(terms)
  const [smstGroup, set_smstGroup] = useState([])
  const uptRef = useRef(false)

  //
  const recordRef = useRef(defRecord)

  // const defLschList = useMemo(() => {
  // 	const lschList = []
  // 	const lsch = {
  // 		id: -1,
  // 		lectureId: -1,
  // 		weekCode: "-1",
  // 		startTime: null,
  // 		endTime: null,
  // 	}
  //
  // 	codes
  // 		.filter((c) => c.codeGroupId === g_week_code)
  // 		.forEach((w) => {
  // 			lschList.push({ ...lsch, weekCode: w.code })
  // 		})
  //
  // 	return lschList
  // },[])



  const defLschList = () => {
    const lschList = []
    const lsch = {
      id: -1,
      lectureId: -1,
      weekCode: '-1',
      startTime: null,
      endTime: null,
    }

    codes
      .filter((c) => c.codeGroupId === g_week_code)
      .forEach((w) => {
        lschList.push({ ...lsch, weekCode: w.code })
      })

    return lschList
  }

  const ltgList = useMemo(() => {
    const ltgList = []
    const ltg = {
      id: -1,
      lectureId: -1,
      grade: -1,
    }
    for (let i = 1; i < 7; i++) {
      ltgList.push({ ...ltg, grade: i })
    }
    return ltgList
  }, [])

  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  const onLoad = async () => {
    const schoolId = schola.hasOwnProperty('id') ? schola.id : -1

    const phaseFrom = tabValue === '1' ? 0 : 2
    const phaseUntil = tabValue === '1' ? 2 : 3

    let url = `/lecture/array/${schoolId}`
    const newTerms = {}
    Object.keys(termsRef.current).forEach((key) => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key]
      }
    })

    let tempList
    openIndicator()
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
      phaseFrom: phaseFrom,
      phaseUntil: phaseUntil,
    })
    closeIndicator()

    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)

      if (repMessage.totalCount) {
        const totalCount = repMessage.totalCount
        set_totalCount(totalCount)
      }

      for (const lecture of records) {
        lecture.smstId = lecture.smst.id
        lecture.year = lecture.smst.year
        lecture.gisu = lecture.smst.gisu
        lecture.schoolName = lecture.school.name
        lecture.teacherName = lecture.teacher.name
        lecture.smstPhase = lecture.smst.phase < 2 ? 1 : 2
        const filename = lecture.filename ?? ''
        const uname = lecture.imgUrl ? lecture.imgUrl.split('/').pop() : ''
        const path = uname ? lecture.imgUrl.substring(0, lecture.imgUrl.lastIndexOf('/')) : ''
        lecture.imgUrl = lecture.imgUrl ? `/scm/repo/${path}/${encodeURIComponent(uname)}` : no_image

        // if('serviceWorker' in navigator) {
        //   navigator.serviceWorker.controller?.postMessage({ action: 'cacheUrl', url: lecture.imgUrl  });
        // }
        // else {
        //   console.log('servierWorker not available')
        // }

        lecture.attchList = [{ id: lecture.attchId, name: filename }]

        lecture.isDetail = false
        lecture.weekCodeList = []
        lecture.lschList = defLschList()
        lecture.ltgList = []
        lecture.feeCodeList = []
        // lecture.selName = statCodeList.find((d) => d.id === lecture.statCode)?.name
        lecture.selName = selCodeList.find((d) => d.id === lecture.selCode)?.name
        lecture.statCodeName = statCodeList.find((d) => d.id === lecture.statCode)?.name

        lecture.weekString = ''
        // let weekString = ''
        // lecture.lschs.sort((a, b) => a.weekCode.localeCompare(b.weekCode))
        // lecture.lschs.forEach((lsch) => {
        //   weekString += weekCodeList.find((d) => d.code === lsch.weekCode)?.name.substring(0, 1)
        //   weekString += `(${lsch.startTime}~${lsch.endTime})`
        //   weekString += '\n'
        // })
        // if (weekString.endsWith(',')) {
        //   weekString = weekString.slice(0, -1)
        // }
        // lecture.weekString = weekString

        lecture.ltgString = ''
        let ltgString = ''
        lecture.ltgs.sort((a, b) => a.grade - b.grade)
        lecture.ltgs.forEach((ltg) => {
          ltgString += ltg.grade + ','
        })
        if (ltgString.endsWith(',')) {
          ltgString = ltgString.slice(0, -1)
        }
        lecture.ltgString = ltgString

        let sugangFee = lecture.fees
          .filter((r) => r.feeCode === 'S002' || r.feeCode === 'S003' || r.feeCode === 'S007')
          .reduce((acc, fee) => acc + fee.price, 0)
        let feePerTime = lecture.lecCount > 0 ? parseInt(sugangFee / lecture.lecCount) : sugangFee
        lecture.feePerTime = comma(feePerTime)
        let otherFee = lecture.fees.filter((r) => r.feeCode === 'S004' || r.feeCode === 'S005' || r.feeCode === 'S006').reduce((acc, fee) => acc + fee.price, 0)
        // let bojoFee = lecture.fees.filter((r) => r.feeCode === 'S007').reduce((acc, fee) => acc + fee.price, 0)

        lecture.feeAll = comma(sugangFee) + '(수강료)' + '\n' + comma(otherFee) + '(교재비등)'

        lecture.rrsNum = `${lecture.rcrNum}/${lecture.reqNum}/${lecture.prcNum}/${lecture.sttNum}`
      }

      // records.sort((a, b) => a.title.localeCompare(b.title))
      // const smstGroup = records.reduce((acc, cur) => {
      //   const key = '' + cur.year + '/' + cur.gisu
      //   if (acc[key]) {
      //     acc[key].push(cur)
      //   } else {
      //     acc[key] = [cur]
      //   }
      //   cur.groupId = key
      //   return acc
      // }, {})

      // const sortedObjects = {}
      // const sortedKeys = Object.keys(smstGroup).sort().reverse()
      // sortedKeys.forEach((key) => {
      //   sortedObjects[key] = smstGroup[key]
      // })

      // originRef.current = sortedObjects
      originRef.current = records
      set_counter(counter + 1)
    }
  }

  const fetchExtra = async (lectureId) => {
    const url = '/lecture/lsch/ltg'
    openIndicator()
    const resp = await WebService.get(url, { lectureId: lectureId })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const extra = JSON.parse(resp.repMessage)
    return extra
  }

  const fetchChildren = async (lectureId) => {
    const url = '/lecture/children'
    openIndicator()
    const resp = await WebService.get(url, { lectureId: lectureId })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.report)
  }

  const onDetail = async (groupId, lectureId) => {
    // const extra = await fetchExtra(lectureId)
    const extra = await fetchChildren(lectureId)
    console.log('extra', extra)
    if (!extra) {
      return
    }

    const lschs = extra.lschs
    const ltgs = extra.ltgs
    // const fees = extra.fees
    // fees.sort((a, b) => a.sqNum - b.sqNum)
    const fees = []
    // const now = moment().format(dateFormat)

    // console.log('extrafees=>', extra.fees)
    feeCodeList.forEach((feeCode) => {
      const found = extra.fees.find((r) => r.feeCode === feeCode.code)
      if (found) {
        fees.push({ ...found })
      }
      // else {
      //   const fee = {
      //     id: -1,
      //     lectureId: lectureId,
      //     feeCode: feeCode.code,
      //     statCode: 'S001',
      //     price: 0,
      //     uptTime: now,
      //     regTime: now,

      //   }
      //   fees.push(fee)
      // }
    })

    const attdncs = extra.attdncs

    const newDataList = { ...dataList }
    const lecture = newDataList[groupId].find((d) => d.id === lectureId)

    lecture.lschList = defLschList()
    const tempWeekCodeList = []
    lschs.forEach((lsch) => {
      const weekCode = weekCodeList.find((w) => w.code === lsch.weekCode)
      tempWeekCodeList.push(weekCode)

      const localLsch = lecture.lschList.find((lsch2) => lsch2.weekCode === lsch.weekCode)
      localLsch.startTime = `2000-01-01 ${lsch.startTime}:00`
      localLsch.endTime = `2000-01-01 ${lsch.endTime}:00`
    })

    lecture.weekCodeList = tempWeekCodeList

    // 학년
    lecture.ltgList = ltgs
    // 요금
    lecture.feeList = fees

    set_dataList(newDataList)

    set_detailScreen(true)
    dgHandler[1](true)
  }

  const onSchedule = async (id) => { }

  const onDelete = async (id) => {
    const url = '/lecture'
    openIndicator()
    const resp = await WebService.delete(url, { id: id, schoolId: schola.id })
    closeIndicator()
    if (resp.repCode === 'ack') {
      alert('삭제되었습니다.', () => onLoad())
    }
    else {
      alert(resp.repMessage)
    }
  }

  const onDelete2 = async (id) => {
    const url = '/smst/force/delete'
    openIndicator()
    const resp = await WebService.delete(url, { id: id, schoolId: schola.id })
    closeIndicator()
    if (resp.repCode === 'ack') {
      alert('삭제되었습니다.', () => onLoad())
    }
    else {
      alert(resp.repMessage)
    }
  }

  const handleDownload = async () => {
    const serverUrl = encodeURI('/lecture/download/tmpl')
    const response = await axios.get(serverUrl, {
      responseType: 'blob', // Set responseType to 'blob' for binary data
    })

    //
    const contentDispositionHeader = response.headers['content-disposition']
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(contentDispositionHeader)
    let suggestedFilename = 'downloaded_file' // Default filename if not found

    if (matches != null && matches[1]) {
      suggestedFilename = matches[1].replace(/['"]/g, '') // Remove quotes if present
    }

    // Create a Blob object from the response data
    const blob = new Blob([response.data], { type: response.headers['content-type'] })

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob)

    // Create a link element to trigger the download
    const link = document.createElement('a')
    link.href = url
    link.download = suggestedFilename
    document.body.appendChild(link)

    // Trigger the download
    link.click()

    // Clean up the temporary URL and link
    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }

  const preDelete = async (lecture) => {
    const regis = await fetchRegis(lecture.id)
    if (!regis) {
      alert('에러가 발생했습니다.')
      return
    }

    if (regis.length > 0) {
      alert('강좌에 수강신청이 되어 있어 삭제할 수 없습니다.')
      return
    }

    return true
  }

  const preDelete2 = async (smstId) => {
    const regis = await fetchRegis2(smstId)
    if (!regis) {
      alert('에러가 발생했습니다.')
      return
    }

    if (regis.length > 0) {
      alert('강좌 중 수강신청 데이터가 있어 삭제할 수 없습니다.')
      return
    }

    return true
  }

  const fetchSmst = async () => {
    const url = `/smst/standby/lecture/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {})
    closeIndicator()
    if (resp.repCode !== 'ack') {
      // openSnackbar(resp.repMessage);
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const smst = JSON.parse(repMessage.smst)
    return smst
  }

  const fetchSmstList = async () => {
    const url = `/smst/standby2/lecture/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {})
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const smstList = JSON.parse(repMessage.records)
    return smstList
  }

  const onCreate = async () => {
    const smstList = await fetchSmstList()
    if (!smstList) {
      return
    }

    const now = moment().format(dateFormat)
    const newRecord = {
      ...defRecord,
      reqNum: 0,
      prcNum: 0,
      sttNum: 0,
      lecCount: 0,
      statCode: 'S000',
      selCode: '',
      phase: 0,
      imgUrl: no_image,
      regTime: now,
      uptTime: now,
      files: [{ name: '' }],
      teachers: [],
      interLectures: [],
      attchList: [],
    }

    newRecord.weekCodeList = []
    newRecord.lschList = defLschList()
    newRecord.ltgList = []
    newRecord.feeList = []

    newRecord.smstId = smstList.length == 1 ? smstList[0].id : -1
    newRecord.groupId = ''
    newRecord.isNew = true
    newRecord.smstList = smstList
    recordRef.current = newRecord
    set_detailScreen(true)
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach((k) => {
      obj[k] = ''
    })
    set_terms(obj)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }

  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  const findCode = (codeGroupId, code) => {
    const found = codes.filter((d) => d.codeGroupId === codeGroupId).find((d) => d.code === code)
    return found
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }))

  useEffect(() => {
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  }, [location])

  useEffect(() => {
    if (prev_tabValueRef.current != tabValue) {
      prev_tabValueRef.current = tabValue
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  }, [tabValue])

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    if (originRef.current) {
      const td = transformData(originRef.current, sortBy, sortDirection)
      set_dataList(td)
    }
  }, [counter])

  const dg_title = '강좌 정보'
  const memo_DgContent = useMemo(() => {
    return (
      <ManagerLecturePartDetail
          fields={fields}
          record={recordRef.current}
          dialogHandler={dgHandler}
        callback={(updated) => {
            console.log('callback.........')
            if (updated) {
              onLoad()
            }
            set_detailScreen(false)
          }}
        />
    )
  }, [recordRef.current])

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
  }

  const ImageCell = ({ imgUrl }) => {
    const imgHandler = useState(false)
    const memoUrl = useMemo(() => imgUrl, [imgUrl])
    const handleViewImage = () => {
      if (recordRef.current.imgUrl.startsWith('data:')) {
        alert('이미지가 없습니다.')
      }
      else {
        imgHandler[1](true)
      }
    }

    useEffect(() => {
      console.log('imgUrl', imgUrl)
    }, [imgUrl])

    return (
      <Fragment>
        <div onClick={() => handleViewImage()} style={{ cursor: 'pointer' }}>
          <img src={memoUrl} alt="lecture" style={{ width: 30 }} />
        </div>
        {imgHandler[0] ? <ManagerLecturePartImg dialogHandler={imgHandler} imgUrl={memoUrl} /> : null}
      </Fragment>
    )
  }

  const ImageComponent = ({ src }) => {
    const [image, setImage] = useState(null)
    const loadImage = useMemo(() => {
      return (src) => {
        return new Promise((resolve, reject) => {
          const img = new Image()
          img.src = src
          img.onload = () => resolve(img)
          img.onerror = () => reject(new Error(`Failed to load image from ${src}`))
        })
      }
    }, []) // The empty dependency array ensures it's only created once

    useEffect(() => {
      loadImage(src)
        .then((cachedImage) => {
          setImage(cachedImage)
        })
        .catch((error) => {
          console.error('Error loading image:', error)
        })
    }, [src])

    return <img src={image ? image.src : ''} alt="lecture" style={{ width: 30 }} />
  }

  const Body = ({ smstPhase }) => {
    if (dataList != null) {
      return (
        <div ref={inputRef}>
          {Math.floor(smstPhase) === 1 ? (
            <>
              <div>
                <Typography color={theme.palette.secondary.dark}>
                  ※ 강좌 생성 전 교내 공휴일이 먼저 등록되어 있어야 강좌에 반영될 수 있습니다.(일정 &gt; 교내 공휴일 관리 )
                </Typography>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ mr: 1 }}
                  onClick={() => {
                    onCreate()
                  }}
                >
                  생성
                </Button>
                <Button
                  startIcon={<FileUploadOutlinedIcon />}
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ mr: 1 }}
                  onClick={async () => {
                    const smst = await fetchSmstList()
                    if (smst) {
                      dgRef.current.open()
                    }
                    // uploadHandler[1](true)
                  }}
                >
                  파일로 생성
                </Button>
                <Button startIcon={<FileDownloadOutlinedIcon />} variant="outlined" color="primary" size="small" sx={{ mr: 1 }} onClick={handleDownload}>
                  샘플 파일 다운로드
                </Button>
              </div>
            </>
          ) : null}

          <div style={{ paddingTop: 20 }}>
            <MUITable sx={{ minWidth: 1200 }}>
              <MyTableHead>
                <TableRow>
                  {fields.map((col, index2) => {
                    if (col.visible) {
                      return (
                        <TableCell key={index2} size="small" style={{ width: col.width ?? null }}>
                          <Typography variant="body2" fontSize={'0.9em'} fontWeight={'bold'}>
                            {col.sortable ? (
                              <TableSortLabel
                                active={sortBy === col.field}
                                // 현재 정렬 상태를 그대로 보여줘야 화살표 방향이 상식적으로 움직임?
                                direction={sortDirection}
                                onClick={() => handleSort(col.field)}
                              >
                                {col.placeholder}
                              </TableSortLabel>
                            ) : (
                              <>{col.placeholder}</>
                            )}
                          </Typography>
                          {col.canSrch ? (
                            <Fragment>
                              <br />
                              <TextField
                                label=""
                                variant="outlined"
                                size="small"
                                inputProps={{
                                  style: {
                                    fontSize: '0.875em',
                                    padding: 5,
                                    backgroundColor: '#fff',
                                  },
                                }}
                                value={terms[col.field]}
                                onChange={(e) => {
                                  const newTerms = { ...terms }
                                  newTerms[col.field] = e.target.value
                                  set_terms(newTerms)
                                }}
                              />
                            </Fragment>
                          ) : (
                            <Fragment>
                              {/*<br />*/}
                              {/*<br />*/}
                            </Fragment>
                          )}
                        </TableCell>
                      )
                    }
                  })}
                  <TableCell size="small" align={'center'}>
                    관리
                  </TableCell>
                </TableRow>
              </MyTableHead>
              <TableBody>
                {Object.keys(dataList).map((groupId, gidx) =>
                  dataList[groupId].findIndex((r) => Math.floor(+r.smstPhase) === +smstPhase) >= 0 ? (
                    <Fragment key={`group-${smstPhase}-${groupId}`}>
                      <TableRow key={`header-${smstPhase}-${groupId}`}>
                        <TableCell rowSpan={dataList[groupId].length + 1}>
                          {dataList[groupId].length > 0 ? (
                            <>
                              <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                {groupId}
                              </Typography>
                              <br />
                              <ConfirmDialog
                                btn={
                                  <FlatButton color={'error'} sx={{ whiteSpace: 'pre-line' }}>
                                    전체{'\n'}삭제
                                  </FlatButton>
                                }
                                title={'주의'}
                                content={'수강신청 데이터가 존재하는 경우에는 삭제할 수 없습니다.  해당 학기및 학기의 전체강좌를 삭제 하시겠습니까?'}
                                bc={'error'}
                                preHandle={() => {
                                  const smstId = dataList[groupId][0].smstId
                                  return preDelete2(smstId)
                                }}
                                perform={() => {
                                  const smstId = dataList[groupId][0].smstId
                                  onDelete2(smstId)
                                }}
                              />
                              <br />
                              <br />
                              <Typography variant="body2" color={theme.palette.secondary.main} sx={{ fontSize: '0.8em' }}>
                                ※ 수강신청 데이터가
                                <br /> 없을 경우
                                <br /> 전체 강좌 삭제 가능
                              </Typography>
                            </>
                          ) : (
                            <Typography>데이터 없음</Typography>
                          )}
                        </TableCell>
                      </TableRow>
                      {dataList[groupId].map((row, index) => {
                        return (
                          <TableRow
                            key={`row-${smstPhase}-${groupId}-${row.id}-${index}`}
                            onMouseEnter={() => {
                              recordRef.current = row
                            }}
                            style={{
                              cursor: row.drop ? 'not-allowed' : 'default',
                              pointerEvents: row.drop ? 'none' : 'auto', // 이 행의 모든 클릭을 원천 차단
                            }}
                          >
                            {fields.map((col, index2) => {
                              if (col.visible && col.field !== 'smstName') {
                                const isAllowedInDrop = col.field === 'id' || col.field === 'title' || col.field === 'weekString'

                                // 만약 drop인 행인데 허용된 필드가 아니라면 빈 셀 반환
                                if (row.drop && !isAllowedInDrop) {
                                  return <TableCell key={smstPhase + index2} size="small" />
                                }

                                return (
                                  <TableCell key={smstPhase + index2} size="small" style={{ whiteSpace: 'pre-line' }}>
                                    {col.field === 'imgUrl' ? (
                                      <ImageCell22 id={row.id} imgUrl={row[col.field]} recordRef={recordRef} />
                                    ) : col.field === 'teacherName' ? (
                                      <>
                                        <Typography variant="body2">{row.teacherName}</Typography>
                                        {row.teachers.map((t) => (
                                          <Typography variant="body2">{t.name}</Typography>
                                        ))}
                                      </>
                                    ) : (
                                      <Typography variant="body2" fontWeight={col.field === 'title' ? 'bold' : 'normal'} fontSize={'0.9em'}>
                                        {row[col.field]}
                                      </Typography>
                                    )}
                                  </TableCell>
                                )
                              }
                            })}
                            <TableCell size="small" style={{ height: 45 }}>
                              {!row.drop && (
                                <Grid container spacing={1} style={{ width: 200 }}>
                                  <Grid item xs={6}>
                                    <FlatButton
                                      variant="outlined" size="small" fullWidth startIcon={<SettingsIcon />} onClick={() => onDetail(groupId, row.id)}
                                    >
                                      설정
                                    </FlatButton>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <ConfirmDialog
                                      btn={
                                        <FlatButton fullWidth color={'error'}>
                                          삭제
                                        </FlatButton>
                                      }
                                      title={'주의'}
                                      content={'수강신청 데이터가 존재하는 경우에는 삭제할 수 없습니다. 해당 강좌를 삭제 하시겠습니까?'}
                                      bc={'error'}
                                      preHandle={() => {
                                        return preDelete(row)
                                      }}
                                      perform={() => {
                                        onDelete(row.id)
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </Fragment>
                  ) : null
                )}
              </TableBody>
            </MUITable>

            {/*
            {renderIndicator()}
            {renderAlert()}
              */}
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div style={{ paddingRight: 10 }}>
          <h1>강좌 관리 </h1>
        </div>
      </div>

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: '#fff' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="현재" value="1" />
              <Tab label="이전내역" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="1" />
          </TabPanel>
          <TabPanel value="2" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="2" />
          </TabPanel>
        </TabContext>
      </Box>
      <MyDialog3
        title={dg_title}
        component={memo_DgContent}
        dialogHandler={dgHandler}
        placeClose={true}
        callback={() => {

          set_detailScreen(false)
          if (uptRef.current) {
            onLoad()
          }
        }}
      />
      <div>
        {/* TODO uploadHandler no more used, delete it after  */}
        {/* {uploadHandler[0] ? <ManagerLecturePartUpload dialogHandler={uploadHandler} callback={onLoad} /> : null} */}

        {<ManagerLecturePartUpload2 ref={dgRef} callback={onLoad} />}
        {<ManagerLecturePartPriorUpload ref={dgRef2} callback={onLoad} />}
        {renderAlert()}
      </div>
    </>
  )
}

export default ManagerLecturePage
